/**
 * Migration script to update localStorage keys with CED prefix
 * This ensures CED and TECD use separate cache keys
 */

const CED_PREFIX = 'ced:';

// List of keys that need to be migrated
const KEYS_TO_MIGRATE = [
  'user-info',
  'language',
  'popupModal',
  'registerKYCForm',
  'pathBeforeSignIn',
  'userToken',
  'username',
  'role',
  'utmParams'
];

// List of sessionStorage keys that need to be migrated
const SESSION_KEYS_TO_MIGRATE = [
  'previousUrl'
];

export const migrateLocalStorageKeys = () => {
  let migratedCount = 0;
  
  // Migrate localStorage keys
  KEYS_TO_MIGRATE.forEach(key => {
    const oldKey = key;
    const newKey = CED_PREFIX + key;
    
    // Check if old key exists
    const oldValue = localStorage.getItem(oldKey);
    if (oldValue !== null) {
      // Migrate to new key
      localStorage.setItem(newKey, oldValue);
      localStorage.removeItem(oldKey);
      migratedCount++;
    }
  });
  
  // Migrate sessionStorage keys
  SESSION_KEYS_TO_MIGRATE.forEach(key => {
    const oldKey = key;
    const newKey = CED_PREFIX + key;
    
    // Check if old key exists
    const oldValue = sessionStorage.getItem(oldKey);
    if (oldValue !== null) {
      // Migrate to new key
      sessionStorage.setItem(newKey, oldValue);
      sessionStorage.removeItem(oldKey);
      migratedCount++;
    }
  });
  
  return migratedCount;
};

export const clearOldKeys = () => {
  // Clear localStorage keys
  KEYS_TO_MIGRATE.forEach(key => {
    const oldValue = localStorage.getItem(key);
    if (oldValue !== null) {
      localStorage.removeItem(key);
    }
  });
  
  // Clear sessionStorage keys
  SESSION_KEYS_TO_MIGRATE.forEach(key => {
    const oldValue = sessionStorage.getItem(key);
    if (oldValue !== null) {
      sessionStorage.removeItem(key);
    }
  });
};

// Auto-migrate on import
if (typeof window !== 'undefined') {
  migrateLocalStorageKeys();
}
